// Original Cairo-inspired tile illustrations, keyed by permanent board position.
// Keep silhouettes distinct and strokes broad enough for the angled game camera.
export function drawCairoPropertyArt(c:CanvasRenderingContext2D,position:number,palette?:readonly [string,string,string,string]){
  const ink='#071714',[gold,teal,sand,paper]=palette??['#b77524','#267b76','#e4ba72','#fff0c9']
  c.save();c.translate(256,365);c.scale(1.4,1.4)
  c.strokeStyle=ink;c.lineWidth=5;c.lineJoin='round';c.lineCap='round'
  const path=(d:string,fill?:string)=>{const p=new Path2D(d);if(fill){c.fillStyle=fill;c.fill(p)}c.stroke(p)}
  const rect=(x:number,y:number,w:number,h:number,fill:string)=>{c.fillStyle=fill;c.fillRect(x,y,w,h);c.strokeRect(x,y,w,h)}
  const oval=(x:number,y:number,rx:number,ry:number,fill:string)=>{c.beginPath();c.ellipse(x,y,rx,ry,0,0,Math.PI*2);c.fillStyle=fill;c.fill();c.stroke()}
  switch(position){
    case 1: // Al Muizz: a carved minaret.
      rect(-24,-20,48,78,sand);rect(-31,-30,62,12,gold);rect(-16,-64,32,32,paper)
      path('M-22 -64 L0 -89 L22 -64 Z',teal);path('M0 -89 V-99 M-36 59 H36 M-7 56 V20 Q0 4 7 20 V56')
      path('M-15 -5 H15 M-15 8 H15 M0 -52 V-40');break
    case 3: // Khan el Khalili: a market lantern.
      oval(0,-67,11,12,gold);path('M-35 -43 L0 -57 L35 -43 L44 37 L0 61 L-44 37 Z',gold)
      path('M-23 -32 L23 -32 L29 29 L0 43 L-29 29 Z',teal)
      path('M0 -29 L14 4 L0 29 L-14 4 Z',paper);path('M0 62 V76 M-11 76 H11');break
    case 6: // Al Azhar: a turquoise dome and crescent.
      rect(-65,5,130,49,sand);path('M-58 3 Q-56 -45 0 -65 Q56 -45 58 3 Z',teal)
      path('M0 -66 V-80 M11 -96 Q-14 -105 -13 -85 Q-9 -72 8 -80')
      path('M-13 53 V27 Q0 3 13 27 V53 M-44 22 V38 M44 22 V38');break
    case 8: // Gamaliya: a carved pointed window.
      path('M-50 62 V-12 Q-47 -49 0 -78 Q47 -49 50 -12 V62 Z',gold)
      path('M-34 46 V-9 Q-31 -35 0 -57 Q31 -35 34 -9 V46 Z',teal)
      path('M0 -45 V43 M-31 -4 H31 M-31 23 H31 M-30 -7 L0 22 L30 -7 M-30 23 L0 44 L30 23');break
    case 9: // Bab al Futuh: twin rounded gate towers.
      rect(-72,-37,42,95,sand);rect(30,-37,42,95,sand);rect(-30,-23,60,81,gold)
      oval(-51,-37,21,9,paper);oval(51,-37,21,9,paper)
      path('M-18 58 V14 Q0 -16 18 14 V58 Z',teal)
      path('M-53 -15 V0 M51 -15 V0 M-72 18 H-30 M30 18 H72');break
    case 11: // Talaat Harb: an ornate coffee pot.
      path('M-30 -38 H24 L32 37 Q26 66 -26 58 Q-44 49 -34 22 Z',gold)
      path('M24 -25 Q82 -50 65 3 Q55 27 30 19 M-32 -13 L-66 -40 L-73 -35 L-49 19 L-35 23',sand)
      path('M-38 -39 Q-5 -73 31 -39 Z',teal);oval(-4,-68,6,6,gold)
      path('M-26 26 Q-1 7 27 26 M-24 39 Q0 23 27 39');break
    case 13: // Qasr el Nil: bridge over the river.
      path('M-90 3 H90 V27 H-90 Z',sand)
      path('M-77 26 Q-48 -13 -19 26 M-13 26 Q16 -13 45 26 M49 26 Q69 0 86 26')
      path('M-86 -32 V4 M86 -32 V4 M-86 -17 H86 M-53 -17 V2 M-17 -17 V2 M19 -17 V2 M55 -17 V2')
      c.strokeStyle=teal;path('M-90 45 Q-67 29 -44 45 T2 45 T48 45 T94 45 M-75 62 Q-52 46 -29 62 T17 62 T63 62');break
    case 14: // Mohamed Mahmoud: artist's palette and brush.
      path('M-53 -51 Q-5 -88 46 -47 Q77 -22 45 -8 Q16 0 24 24 Q37 52 0 61 Q-62 65 -70 17 Q-83 -24 -53 -51 Z',sand)
      oval(-29,-29,10,10,teal);oval(0,-45,10,10,gold);oval(-48,3,10,10,'#b65338');oval(-27,30,10,10,teal)
      path('M9 48 L58 -42 L70 -36 L21 55 Z',gold);path('M58 -42 Q51 -67 79 -79 Q80 -49 70 -36 Z',teal);break
    case 16: // Sherif Street: decorative key.
      oval(-38,-25,32,32,gold);oval(-38,-25,12,12,paper)
      path('M-14 -8 L70 52 L57 70 L42 60 L50 49 L33 37 L25 48 L11 38 L18 27 L-24 0 Z',gold);break
    case 18: // Adly Street: theatre curtains and stage.
      rect(-73,-58,146,118,gold);rect(-60,-45,120,91,teal)
      path('M-60 -45 H-10 Q-8 -7 -49 9 L-60 44 Z M60 -45 H10 Q8 -7 49 9 L60 44 Z','#b65338')
      path('M-76 61 H76 M-47 6 L-60 16 M47 6 L60 16');oval(0,2,11,11,paper);path('M0 13 V37 M-16 23 H16');break
    case 19: // Abdel Khaleq: balance scales.
      path('M0 -62 V62 M-66 -37 H66 M-37 63 H37');oval(0,-65,8,8,gold)
      path('M-57 -37 L-80 16 H-34 Z M57 -37 L34 16 H80 Z',sand)
      path('M-81 18 Q-57 56 -33 18 Z M33 18 Q57 56 81 18 Z',teal);break
    case 21: // Champollion: an unfurled papyrus.
      path('M-54 -61 H57 V58 H-54 Q-77 47 -54 35 Z',paper)
      oval(-54,-61,14,10,gold);path('M-54 -50 V35 M-54 58 H68 Q85 48 68 36 H-54',sand)
      path('M-29 -30 H31 M-29 -8 H12 M-29 14 H30');path('M28 -22 L43 -8 L28 6',teal);break
    case 23: // Sabri Abu Alam: tiered fountain.
      oval(0,49,77,18,teal);path('M-61 46 Q0 81 61 46 M0 42 V-31')
      path('M-45 -7 Q0 38 45 -7 Z',sand);path('M-29 -41 Q0 -9 29 -41 Z',gold)
      c.strokeStyle=teal;path('M0 -42 Q-20 -89 -42 -51 M0 -42 Q20 -89 42 -51 M-39 2 Q-62 -6 -63 27 M39 2 Q62 -6 63 27');break
    case 24: // Hoda Shaarawi: a lotus blossom.
      path('M0 27 Q-36 -16 0 -72 Q36 -16 0 27 Z',paper)
      path('M0 32 Q-66 20 -66 -42 Q-15 -31 0 32 Z M0 32 Q66 20 66 -42 Q15 -31 0 32 Z',gold)
      path('M0 38 Q-67 56 -85 0 Q-29 -2 0 38 Z M0 38 Q67 56 85 0 Q29 -2 0 38 Z',teal)
      path('M0 37 V67 M-34 68 H34');break
    case 26: // Corniche el Nil: a felucca sailboat.
      path('M-76 31 H77 L49 56 H-42 Z',gold);path('M-7 31 V-74')
      path('M-4 -69 L68 21 H-4 Z',paper);path('M-17 -48 L-62 18 H-17 Z',teal)
      c.strokeStyle=teal;path('M-82 72 Q-59 58 -36 72 T10 72 T56 72');break
    case 27: // Qasr el Aini: a columned portico.
      path('M-78 -30 L0 -72 L78 -30 Z',sand);rect(-78,-28,156,13,gold)
      for(const x of [-55,-18,19,56]){rect(x-7,-11,14,62,paper)}
      rect(-77,54,154,12,sand);path('M-86 76 H86');break
    case 29: // Al Falaki: an astronomical instrument.
      oval(0,0,63,63,gold);oval(0,0,47,47,teal)
      path('M0 -43 V43 M-43 0 H43 M-31 -31 L31 31 M-31 31 L31 -31')
      path('M-15 12 L28 -35 L12 16 L-28 34 Z',paper);oval(0,-78,10,10,gold);break
    case 31: // Mansour Street: courtyard palm.
      path('M-10 61 L0 -22 L13 61 Z',gold)
      path('M0 -23 Q-47 -72 -75 -10 Q-33 -29 0 -23 Q38 -72 78 -10 Q35 -31 0 -23 Q-12 -82 20 -78 Q28 -47 0 -23 Z',teal)
      path('M-37 60 H38 L26 77 H-25 Z',sand);oval(-9,-15,8,8,gold);oval(10,-14,8,8,gold);break
    case 33: // 26 July Street: vintage city tram.
      path('M-66 -43 Q0 -66 66 -43 V45 H-66 Z',teal)
      rect(-52,-29,29,38,paper);rect(-15,-29,30,38,paper);rect(23,-29,29,38,paper)
      path('M-66 22 H66 M-45 -50 L0 -75 L45 -50');oval(-39,45,13,13,ink);oval(39,45,13,13,ink)
      path('M-82 67 H82 M-45 60 L-57 79 M45 60 L57 79');break
    case 34: // Brazil Street: cafe cup.
      path('M-53 -18 H38 V12 Q34 50 -7 50 Q-48 50 -53 12 Z',teal)
      path('M40 -10 Q85 -18 70 18 Q59 34 36 26');oval(-7,-18,46,11,gold)
      path('M-76 58 Q-5 87 67 58 Z',sand);path('M-28 -42 Q-42 -57 -25 -75 M2 -40 Q-11 -58 6 -78 M29 -40 Q15 -53 32 -69');break
    case 36: // Ismail Mohamed: flowering wrought-iron balcony.
      path('M-61 59 V-16 Q-55 -69 0 -75 Q55 -69 61 -16 V59 Z',sand)
      path('M-38 25 V-12 Q-34 -46 0 -52 Q34 -46 38 -12 V25 Z',teal)
      rect(-77,32,154,34,gold);path('M-77 27 H77 M-50 35 V64 M-25 35 V64 M0 35 V64 M25 35 V64 M50 35 V64')
      oval(-57,21,12,12,'#b65338');oval(57,21,12,12,'#b65338');break
    case 38: // Al Aharam: pyramids at Giza.
      path('M-89 57 L-17 -65 L52 57 Z',sand);path('M-17 -65 L7 57 H52 Z',gold)
      path('M13 57 L58 -23 L100 57 Z',sand);path('M58 -23 L73 57 H100 Z',gold)
      oval(-68,-54,16,16,gold);path('M-99 70 H101');break
  }
  c.restore()
}
